import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 11.488a6.988 6.988 0 1 1 13.976 0 6.988 6.988 0 0 1-13.976 0ZM11.488 3a8.488 8.488 0 1 0 0 16.976 8.488 8.488 0 0 0 0-16.976Zm7.454 14.881a.75.75 0 0 0-1.06 1.061l1.628 1.63a.75.75 0 1 0 1.061-1.062l-1.629-1.629Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m17.881 17.881.248.248-.248-.248Zm1.061 0-.247.248.247-.248Zm-1.06 1.061.247-.247-.248.247Zm1.628 1.63-.247.247.247-.248Zm1.061-1.062.248-.247-.248.247ZM11.488 4.15a7.338 7.338 0 0 0-7.338 7.338h.7a6.638 6.638 0 0 1 6.638-6.638v-.7Zm7.338 7.338a7.338 7.338 0 0 0-7.338-7.338v.7a6.638 6.638 0 0 1 6.638 6.638h.7Zm-7.338 7.338a7.338 7.338 0 0 0 7.338-7.338h-.7a6.638 6.638 0 0 1-6.638 6.638v.7ZM4.15 11.488a7.338 7.338 0 0 0 7.338 7.338v-.7a6.638 6.638 0 0 1-6.638-6.638h-.7Zm-.8 0a8.138 8.138 0 0 1 8.138-8.138v-.7a8.838 8.838 0 0 0-8.838 8.838h.7Zm8.138 8.138a8.138 8.138 0 0 1-8.138-8.138h-.7a8.838 8.838 0 0 0 8.838 8.838v-.7Zm8.138-8.138a8.138 8.138 0 0 1-8.138 8.138v.7a8.838 8.838 0 0 0 8.838-8.838h-.7ZM11.488 3.35a8.138 8.138 0 0 1 8.138 8.138h.7a8.838 8.838 0 0 0-8.838-8.838v.7Zm6.64 14.779a.4.4 0 0 1 .567 0l.494-.495a1.1 1.1 0 0 0-1.555 0l.495.495Zm0 .566a.4.4 0 0 1 0-.566l-.494-.495a1.1 1.1 0 0 0 0 1.555l.495-.494Zm1.63 1.629-1.63-1.63-.494.495 1.629 1.63.495-.495Zm.566 0a.4.4 0 0 1-.566 0l-.495.495a1.1 1.1 0 0 0 1.556 0l-.495-.495Zm0-.566a.4.4 0 0 1 0 .566l.495.495a1.1 1.1 0 0 0 0-1.556l-.495.495Zm-1.63-1.63 1.63 1.63.495-.495-1.63-1.63-.494.496Z"
    />
  </svg>
);
export default SvgSearch;
